__turbopack_context__.v({
  "actions": "Navbar-module__cJzEcG__actions",
  "active": "Navbar-module__cJzEcG__active",
  "blogTransparent": "Navbar-module__cJzEcG__blogTransparent",
  "btnDemo": "Navbar-module__cJzEcG__btnDemo",
  "btnLogin": "Navbar-module__cJzEcG__btnLogin",
  "container": "Navbar-module__cJzEcG__container",
  "dropdownContainer": "Navbar-module__cJzEcG__dropdownContainer",
  "dropdownIcon": "Navbar-module__cJzEcG__dropdownIcon",
  "dropdownItem": "Navbar-module__cJzEcG__dropdownItem",
  "dropdownMenu": "Navbar-module__cJzEcG__dropdownMenu",
  "dropdownTrigger": "Navbar-module__cJzEcG__dropdownTrigger",
  "fadeIn": "Navbar-module__cJzEcG__fadeIn",
  "header": "Navbar-module__cJzEcG__header",
  "headerOpen": "Navbar-module__cJzEcG__headerOpen",
  "logoArea": "Navbar-module__cJzEcG__logoArea",
  "mobileActions": "Navbar-module__cJzEcG__mobileActions",
  "mobileBtnDemo": "Navbar-module__cJzEcG__mobileBtnDemo",
  "mobileBtnLogin": "Navbar-module__cJzEcG__mobileBtnLogin",
  "mobileDropdown": "Navbar-module__cJzEcG__mobileDropdown",
  "mobileDropdownHeader": "Navbar-module__cJzEcG__mobileDropdownHeader",
  "mobileDropdownSub": "Navbar-module__cJzEcG__mobileDropdownSub",
  "mobileMenu": "Navbar-module__cJzEcG__mobileMenu",
  "mobileMenuOpen": "Navbar-module__cJzEcG__mobileMenuOpen",
  "mobileNavLink": "Navbar-module__cJzEcG__mobileNavLink",
  "mobileNavLinkSub": "Navbar-module__cJzEcG__mobileNavLinkSub",
  "mobileNavList": "Navbar-module__cJzEcG__mobileNavList",
  "mobileToggle": "Navbar-module__cJzEcG__mobileToggle",
  "nav": "Navbar-module__cJzEcG__nav",
  "navItem": "Navbar-module__cJzEcG__navItem",
  "navLink": "Navbar-module__cJzEcG__navLink",
  "navList": "Navbar-module__cJzEcG__navList",
  "scrolled": "Navbar-module__cJzEcG__scrolled",
});
